// firebase.service.ts
import { Inject, Injectable } from '@angular/core';
import { ENVIRONMENT } from '@viso/core/data-access';
import { Environment } from '@viso/core/models';
import { initializeApp, FirebaseApp } from 'firebase/app';
import { getDatabase, Database } from 'firebase/database';

@Injectable({
  providedIn: 'root',
})
export class FireRealtimeService {
  public app: FirebaseApp;
  public db: Database;

  constructor(@Inject(ENVIRONMENT) private env: Environment) {
    this.app = initializeApp({
      apiKey: env.firebaseConfig.apiKey,
      authDomain: env.firebaseConfig.authDomain,
      databaseURL: env.firebaseConfig.databaseURL,
      projectId: env.firebaseConfig.projectId,
      storageBucket: env.firebaseConfig.storageBucket,
      messagingSenderId: env.firebaseConfig.messagingSenderId,
      appId: env.firebaseConfig.appId,
      measurementId: env.firebaseConfig.measurementId,
    });

    this.db = getDatabase(this.app);
  }
}
